export type ClientPlatform = 'web' | 'ios' | 'android' | 'mobile';

const DEVICE_MODEL_MAX_LENGTH = 128;

function sanitizeHeaderValue(value: string): string {
    return value.replace(/[\r\n]/g, ' ').trim().slice(0, DEVICE_MODEL_MAX_LENGTH);
}

export function getClientPlatform(): ClientPlatform {
    if (typeof navigator === 'undefined') {
        return 'web';
    }

    const ua = navigator.userAgent;
    if (/iPad|iPhone|iPod/i.test(ua)) {
        return 'ios';
    }
    if (/android/i.test(ua)) {
        return 'android';
    }
    if (/windows phone/i.test(ua)) {
        return 'mobile';
    }

    return 'web';
}

function getBrowserName(ua: string): string {
    if (/Edg\//i.test(ua)) return 'Edge';
    if (/OPR\//i.test(ua) || /Opera/i.test(ua)) return 'Opera';
    if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) return 'Chrome';
    if (/Firefox\//i.test(ua)) return 'Firefox';
    if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return 'Safari';
    return 'Browser';
}

function getDesktopOsName(ua: string): string {
    if (/Windows NT/i.test(ua)) return 'Windows';
    if (/Mac OS X/i.test(ua)) return 'macOS';
    if (/Linux/i.test(ua)) return 'Linux';
    if (/CrOS/i.test(ua)) return 'ChromeOS';
    return 'Desktop';
}

export function getDeviceModel(): string {
    if (typeof navigator === 'undefined') {
        return 'unknown';
    }

    const ua = navigator.userAgent;

    const androidMatch = ua.match(/;\s*([^;)]+)\s+Build\//i);
    if (androidMatch?.[1]) {
        return sanitizeHeaderValue(androidMatch[1]);
    }

    if (/iPhone/i.test(ua)) return 'iPhone';
    if (/iPad/i.test(ua)) return 'iPad';
    if (/iPod/i.test(ua)) return 'iPod';
    if (/Windows Phone/i.test(ua)) return 'Windows Phone';

    return sanitizeHeaderValue(`${getDesktopOsName(ua)} ${getBrowserName(ua)}`);
}

export function getDeviceHeaders(): Record<string, string> {
    return {
        'X-Client-Platform': getClientPlatform(),
        'X-Device-Model': getDeviceModel(),
    };
}
